/**
 * columnConfig.js - Shared column configuration for TodoList table
 * Defines all columns, their defaults, and helper functions
 */

export const ALL_COLUMNS = [
  { id: 'checkbox', label: '', width: 28, fixed: true, resizable: false },
  { id: 'created_at', label: 'Creado', width: 95, sortable: true, defaultVisible: true },
  { id: 'updated_at', label: 'Últ. Mod.', width: 80, sortable: true, defaultVisible: true },
  { id: 'next_followup_date', label: 'Vencimiento', width: 90, sortable: true, defaultVisible: true },
  { id: 'icon', label: 'IC', width: 70, sortable: true, defaultVisible: true, center: true },
  { id: 'bandera', label: 'Flag', width: 70, sortable: true, defaultVisible: true, center: true },
  { id: 'name', label: 'Nombre', width: null, sortable: true, defaultVisible: true, flex: true },
  { id: 'waiting', label: '✋', width: 45, sortable: true, defaultVisible: true, center: true },
  { id: 'phone', label: 'Teléfono', width: 110, sortable: true, defaultVisible: true },
  { id: 'assigned_to', label: 'Asignado', width: 90, sortable: true, defaultVisible: true },
  { id: 'labels', label: '🏷️', width: 50, sortable: false, defaultVisible: true, center: true },
  { id: 'campaigns', label: '📧', width: 40, sortable: false, defaultVisible: false, center: true },
  { id: 'folder_actions', label: '📋', width: 40, fixed: true, resizable: false },
]

export function getDefaultWidths() {
  return Object.fromEntries(ALL_COLUMNS.filter(c => c.width).map(c => [c.id, c.width]))
}

export function getDefaultVisible() {
  return ALL_COLUMNS.filter(c => c.defaultVisible || c.fixed).map(c => c.id)
}
